import Cookies from "js-cookie";
import { trackPromise } from "react-promise-tracker";
import { logout } from "./authenticationService";

// eslint-disable-next-line no-undef
const base_url = process.env.REACT_APP_API_URL;

const checkResponseOk = (response) => {
    if (!response.ok) {
        if (response.status === 401) { logout(); }
        throw new Error(response.statusText);
    }
};

const handleStatus = (response) => {
    checkResponseOk(response);
    return response.status;
};

const handleJson = (response) => {
    checkResponseOk(response);
    return response.json();
};

const handleResponse = (response) => {
    checkResponseOk(response);
    return response;
};

const handleInviteJson = (response) => {
    if (!response.ok) {
        if (response.status === 401) { logout(); } else if (response.status === 500) {
            throw response.json();
        } else throw new Error(response.statusText);
    }
    return response.json();
};

const handleResendInviteJson = async(response) => {
    if (!response.ok) {
        if (response.status === 401) { logout(); } else if (response.status === 500) {
            throw await response.json();
        } else throw new Error(response.statusText);
    }
    return response.json();
};

const getToken = () => `${Cookies.get("wpm-lightpole-token")}`;

const getHeaders = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("accept", "application/json");
    myHeaders.append("authorization", getToken());
    return myHeaders;
};

export const loginApi = (email, password) => trackPromise(
    fetch(`${base_url}/api/User/SignIn`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({ email, password }),
    }).then((response) => response.json()),
);

export const signupApi = async(params) => {
    const raw = JSON.stringify(params);
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: raw,
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/User/Invite/SignUp`, requestOptions)
        .then(async(response) => {
            if (!response.ok) throw await response.json();
            else return response;
        }),
    );
};

export const getUsersApi = () => trackPromise(
    fetch(`${base_url}/api/User/UsersList/${Cookies.get("wpm-lightpole-email")}`, {
        method: "GET",
        headers: getHeaders(),
    }).then((response) => handleJson(response)),
);

export const inviteApi = async(params) => {
    const raw = JSON.stringify(params);
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: raw,
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/User/Invite`, requestOptions)
        .then((response) => handleInviteJson(response)),
    );
};

export const editUserApi = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };

    return trackPromise(
        fetch(`${base_url}/api/User/UpdateUserDetails`, requestOptions)
        .then((response) => handleResendInviteJson(response)),
    );
};

export const deleteUserApi = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };

    return trackPromise(
        fetch(`${base_url}/api/User/UpdateUserDeleteStatus`, requestOptions).then((response) => handleStatus(response)),
    );
};

export const updateUserActiveStatus = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };

    return trackPromise(
        fetch(`${base_url}/api/User/UpdateUserActiveStatus`, requestOptions).then((response) => handleStatus(response)),
    );
};

export const checkLinkExpiry = (GeneratedDateTime) => trackPromise(
    fetch(`${base_url}/api/User/Invite/CheckLinkExpiration/${GeneratedDateTime}`, {
        method: "GET",
        headers: getHeaders(),
    }).then((response) => handleStatus(response)),
);

export const resendInviteApi = (params) => {
    const raw = JSON.stringify(params);
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: raw,
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/User/Invite`, requestOptions)
        .then((response) => handleResendInviteJson(response)),
    );
};

export const getSchoolListApi = () => trackPromise(
    fetch(`${base_url}/api/School/SchoolList/${Cookies.get("wpm-lightpole-email")}`, {
        method: "GET",
        headers: getHeaders(),
    }).then((response) => handleJson(response)),
);

export const poleRepairMatrix = (poleid) => trackPromise(
    fetch(`${base_url}/api/Pole/PoleRepairMatrix/${poleid}`, {
        method: "GET",
        headers: getHeaders(),
    }).then((response) => handleJson(response)),
);

export const schoolPoleLocationApi = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/School/SchoolPoleLocationData`, requestOptions)
        .then(response => handleJson(response))
    );
};

export const getPoleData = (poleid) => trackPromise(
    fetch(`${base_url}/api/Pole/PoleData/${poleid}`, {
        method: "GET",
        headers: getHeaders(),
    }).then((response) => handleJson(response)),
);

export const getPoleImages = (poleid, imageName, isThumbnail) => fetch(`${base_url}/api/Pole/imgfiles/${poleid}/imagename/${imageName}/${isThumbnail}`, {
    method: "GET",
    headers: getHeaders(),
}).then((response) => handleResponse(response));

export const getRawPoleImage = (poleid, imageName, isThumbnail) => {
    return trackPromise(
        fetch(`${base_url}/api/Pole/imgfiles/${poleid}/imagename/${imageName}/${isThumbnail}`, {
            'method': 'GET',
            'headers': getHeaders()
        }).then(response => handleResponse(response))
    );
}

export const saveCommentApi = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/Pole/SaveComment`, requestOptions)
        .then((response) => handleJson(response)),
    );
}

export const setImagePriority = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/Pole/UpdatePoleImages`, requestOptions)
        .then((response) => handleJson(response)),
    );
};

export const reportServiceApi = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return fetch(`${base_url}/api/School/PDF`, requestOptions)
        .then(response => handleJson(response));
};

export const generateOnePDFReport = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/School/PDF`, requestOptions)
        .then(response => handleJson(response))
    );
};


export const downloadPdfApi = (params, fileName = "Report") => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/download/pdf`, requestOptions)
        .then((response) => response.blob())
        .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${fileName}.pdf`;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove(); // afterwards we remove the element again
        }),
    );
};

export const forgotPasswordApi = (email) => {
    return trackPromise(
        fetch(`${base_url}/api/User/ForgotPassword/${email}`, {
            'method': 'GET',
            'headers': getHeaders()
        })
    );
};

export const resetPasswordApi = (email, password, resetPasswordToken) => {
    return trackPromise(
        fetch(`${base_url}/api/User/ResetPassword`, {
            'method': 'POST',
            'headers': getHeaders(),
            'body': JSON.stringify({ email, password, resetPasswordToken }),
        })
    );
};

export const updatePoleIssueStatusApi = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/Pole/PoleRepairs`, requestOptions)
        .then((response) => handleJson(response)),
    );
};

export const replacePoleApi = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/Pole/PoleRepairs`, requestOptions)
        .then((response) => handleJson(response)),
    );
};

export const RepairCategoriesApi = (poleid) => {
    return trackPromise(
        fetch(`${base_url}/api/Pole/RepairCategories/${poleid}`, {
            'method': 'GET',
            'headers': getHeaders()
        })
    );
};

export const undoRepairHistoryApi = (params) => {
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/Pole/RevertRepairHistory`, requestOptions)
        .then((response) => handleJson(response)),
    );
};

export const ArchiveImageApi = (params) => {
    const requestOptions = {
        method: "Put",
        headers: getHeaders(),
        body: JSON.stringify(params),
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/Pole/ArchiveImage`, requestOptions)
        .then((response) => handleJson(response)),
    );
};

export const uploadImageAPi = (poleid, file) => {
    const formdata = new FormData();
    formdata.append("PoleId", poleid);
    formdata.append("File", file, file.name);

    const myHeaders = new Headers();
    myHeaders.append("authorization", getToken());

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };
    return trackPromise(
        fetch(`${base_url}/api/Pole/UploadImage`, requestOptions)
    );
};

//Microsoft Api's
export const getMicrosoftUserInfoApi = (token) => {
    let myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
    };

    // eslint-disable-next-line no-undef
    return fetch(process.env.REACT_APP_MICROSOFT_GRAPH_API, requestOptions).then(response => handleJson(response));
};

export const microsoftUserCreateApi = (email, firstName, isAdmin) => {
    return fetch(`${base_url}/api/User/microsoft`, {
        'method': 'POST',
        'headers': {
            'content-type': 'application/json',
            'accept': 'application/json',
            'Authorization': getToken()
        },
        'body': JSON.stringify({ email, firstName, isAdmin })
    }).then(response => handleJson(response));
};

export const microsoftUserGroupApi = (token) => {
    let myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    myHeaders.append('content-type', 'application/json');
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
        'body': JSON.stringify({ securityEnabledOnly: true })
    };

    // eslint-disable-next-line no-undef
    return fetch(process.env.REACT_APP_MICROSOFT_USER_GROUP_API, requestOptions).then(response => handleJson(response));
};